<nz-spin [nzSpinning]="isSubmitting() || isDeleting() || definitionResource.isLoading()">
  <form nz-form nzLayout="vertical" [formGroup]="definitionForm" class="definition-form" (ngSubmit)="submitForm()">

    <nz-form-item>
      <nz-form-label nzRequired nzFor="category">Category</nz-form-label>
      @if (isAddingCategory()) {
        <nz-form-control nzValidateStatus="warning" nzWarningTip="Are you sure you intend on creating a new category!" >
          <nz-input-group [nzSuffix]="cancelNewCategoryTpl">
            <input nz-input formControlName="category" id="category" placeholder="New category name" />
          </nz-input-group>
          <ng-template #cancelNewCategoryTpl>
            <span nz-icon nzType="close" nzTheme="outline" (click)="cancelNewCategory()" style="cursor: pointer"></span>
          </ng-template>
        </nz-form-control>
        } @else {
          <nz-form-control nzErrorTip="Category is required!">
            <nz-select formControlName="category" id="category" [nzOptions]="categoryOptions()" nzShowSearch nzPlaceHolder="Select a category" />
          </nz-form-control>
        }
    </nz-form-item>

    <div nz-row [nzGutter]="16">
      <div nz-col [nzXs]="12">
        <nz-form-item>
          <nz-form-label nzFor="arg_type">Type</nz-form-label>
          <nz-form-control>
            <input nz-input placeholder="Argument type" formControlName="arg_type" id="arg_type" />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col [nzXs]="12">
        <nz-form-item>
          <nz-form-label nzFor="unit">Unit</nz-form-label>
          <nz-form-control>
            <input nz-input placeholder="Unit" formControlName="unit" id="unit" />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-form-item>
      <nz-form-label nzFor="default">Default</nz-form-label>
      <nz-form-control>
        <input nz-input placeholder="Default value" formControlName="default" id="default" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="explanation">Explanation</nz-form-label>
      <nz-form-control>
        <textarea nz-input placeholder="Explanation" formControlName="explanation" id="explanation" rows="3"></textarea>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="notes">Notes</nz-form-label>
      <nz-form-control nzExtra="Not displayed to the user">
        <textarea nz-input placeholder="Notes" formControlName="notes" id="notes" rows="2"></textarea>
      </nz-form-control>
    </nz-form-item>

    <div class="form-footer">
      <button nz-button nzType="primary" type="submit">Save</button>
      @if (mode() === "edit") {
        <button nz-button nzType="text" nzDanger type="button" (click)="deleteDefinition()">Delete</button>
      }
    </div>
  </form>
</nz-spin>
